import UI from 'fanplayr-ui'
import PortalI18n from 'PortalI18n'
export default class OffersUtil {

  static fillForFrontend(offers) {
    return offers.map(offer => {
      offer.code = offer.promoCode
      if (offer.promoType === 'file') {
        offer.code = `[${PortalI18n.translate('campaignEdit.offer.Multiple Codes')}]`
      }
      offer.listSummary = OffersUtil.getSummary(offer, {
        id: true,
        displayText: false,
        promoCode: true,
        condition: true,
        language: true,
        validity: true,
        variant: true,
        minPurchase: true
      })
      offer.label = offer.displayText || `[${PortalI18n.translate('campaignEdit.offer.noDisplayText')}]`
      offer.description = offer.listSummary
      offer.isActive = false
      offer.value = offer.id
      return offer
    })
  }
  
  static formatOffer(offer) {
    if (!offer) return null
    const offers = OffersUtil.fillForFrontend([offer])
    return offers && offers.length ? offers[0] : {}
  }

  static getSummary(offer, options) {
    const parts = []
    if (options.id) {
      parts.push(PortalI18n.translate('campaignEdit.offer.idLabel', { value: offer.id }))
    }
    if (options.displayText) {
      parts.push(offer.displayText)
    }
    if (options.promoCode) {
      parts.push(PortalI18n.translate('campaignEdit.offer.codeLabel', { value: offer.code }))
    }
    if (options.condition && offer.condition) {
      parts.push(offer.condition)
    }
    if (options.language && offer.language) {
      parts.push(offer.language.toUpperCase())
    }
    if (options.variant && offer.settings) {
      const config = offer.settings
      const variant = config && config.classes
      if (variant) {
        parts.push(PortalI18n.translate('campaignEdit.offer.variantLabel', { value: variant }))
      }
    }
    if (options.validity) {

      if (offer.validFromDate && offer.expiryDate) {
        parts.push(PortalI18n.translate('campaignEdit.offer.fromXtoYLabel', 
          { value1: UI.format(offer.validFromDate, 'dateShort'), value2: UI.format(offer.expiryDate, 'dateShort') }))
      } else if (offer.validFromDate) {
        parts.push(PortalI18n.translate('campaignEdit.offer.fromXLabel', { value: UI.format(offer.validFromDate, 'dateShort') }))
      } else if (offer.expiryDate) {
        parts.push(PortalI18n.translate('campaignEdit.offer.untilXLabel', { value: UI.format(offer.expiryDate, 'dateShort') }))
      }
    }
    if (options.minPurchase) {
      if (offer.minPurchase > 0) {
        parts.push(PortalI18n.translate('campaignEdit.offer.minimumLabel', { value: offer.minPurchase }))
      } else {
        parts.push(PortalI18n.translate('campaignEdit.offer.noMinimum'))
      }
    }
    // console.log(parts)
    return parts.join(' • ')
  }
}